import axios from 'axios'
import { CADASTRAR_REGITRO_MANUTENCAO_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarManutencaoVeiculo(registro) {
  const url = `${URL}/registro-manutencao-veiculo/cadastrar`;

  return dispatch => axios.post(url, registro, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: CADASTRAR_REGITRO_MANUTENCAO_VEICULO,
      payload: response
    })
  );
}